export const IMAGE_FORMATS = [
  'jpeg',
  'jpg',
  'png',
  'gif',
  'tiff',
  'apng',
  'avif',
  'jfif',
  'pjpeg',
  'pjp',
  'svg',
  'webp',
  'bmp',
  'ico',
  'cur',
  'tif'
]

export const BAR_ATTACHMENTS_FORMATS = ['.png', '.jpg', '.jpeg', '.pdf']
